import type { ReactNode } from 'react';

/** Shared title row for Daily Report previews (matches dashboard widget density). */
export function DailyReportSectionHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <div className="mb-2 flex min-w-0 items-center justify-between gap-2 sm:mb-2.5 sm:gap-3">
      <h2 className="min-w-0 flex-1 truncate text-base font-semibold capitalize text-gray-900 dark:text-white sm:text-lg">
        {title}
      </h2>
      {action ? (
        <div className="flex shrink-0 flex-nowrap items-center justify-end gap-1.5 sm:gap-2">
          {action}
        </div>
      ) : null}
    </div>
  );
}
